import admin from "../models/admin";

export const types = {
  USERS_STATS_REQUESTED: "USERS_STATS_REQUESTED",
  USERS_STATS_SUCCEDDED: "USERS_STATS_SUCCEDDED",
  USERS_REQUESTED: "USERS_REQUESTED",
  USERS_REQUEST_SUCCEDDED: "USERS_REQUEST_SUCCEDDED",
  USERS_REQUEST_FAILED: "USERS_REQUEST_FAILED",
  USERS_DETAIL_REQUESTED: "USERS_DETAIL_REQUESTED",
  USERS_DETAIL_REQUEST_SUCCEDDED: "USERS_DETAIL_REQUEST_SUCCEDDED",
  USERS_DETAIL_REQUEST_FAILED: "USERS_DETAIL_REQUEST_FAILED",
  USER_CONFIRMATION_REQUEST: "USER_CONFIRMATION_REQUEST",
  IMPERSONATE_REQUEST: "IMPERSONATE_REQUEST",
  IMPERSONATE_SUCCEDDED: "IMPERSONATE_SUCCEDDED",
  IMPERSONATE_FAILED: "IMPERSONATE_FAILED",
  DELETIONS_REQUESTED: "DELETIONS_REQUESTED",
  DELETIONS_REQUEST_SUCCEDDED: "DELETIONS_REQUEST_SUCCEDDED",
  DELETIONS_REQUEST_FAILED: "DELETIONS_REQUEST_FAILED",
  GET_GLOBALS_REQUESTED: "GET_GLOBALS_REQUESTED",
  GET_GLOBALS_SUCCEDDED: "GET_GLOBALS_SUCCEDDED",
  GET_GLOBALS_FAILED: "GET_GLOBALS_FAILED",
  UPDATE_GLOBAL_REQUESTED: "UPDATE_GLOBAL_REQUESTED",
  UPDATE_GLOBAL_SUCCEDDED: "UPDATE_GLOBAL_SUCCEDDED",
  UPDATE_GLOBAL_FAILED: "UPDATE_GLOBAL_FAILED",
  MERGE_GLOBAL_REQUESTED: 'MERGE_GLOBAL_REQUESTED',
  MERGE_GLOBAL_SUCCEDDED: 'MERGE_GLOBAL_SUCCEDDED',
  MERGE_GLOBAL_FAILED: 'MERGE_GLOBAL_FAILED',
  CHECK_MERGE_GLOBAL_REQUESTED: 'CHECK_MERGE_GLOBAL_REQUESTED',
  CHECK_MERGE_GLOBAL_SUCCEDDED: 'CHECK_MERGE_GLOBAL_SUCCEDDED',
  CHECK_MERGE_GLOBAL_FAILED: 'CHECK_MERGE_GLOBAL_FAILED',

  MERGE_USER_REQUESTED: 'MERGE_USER_REQUESTED',
  MERGE_USER_SUCCEDDED: 'MERGE_USER_SUCCEDDED',
  MERGE_USER_FAILED: 'MERGE_USER_FAILED',
};


export const actions = {
  getUsers: (options, callback) => {
    return { type: types.USERS_REQUESTED, value: options, callback };
  },
  getUserDetails: (options) => {
    return { type: types.USERS_DETAIL_REQUESTED, value: options };
  },
  getStats: () => {
    return { type: types.USERS_STATS_REQUESTED, value: {} };
  },
  updateConfirmation(id, values, callback) {
    return { type: types.USER_CONFIRMATION_REQUEST, value: { id, values, callback } };
  },
  impersonateUser(id, mod, app) {
    return { type: types.IMPERSONATE_REQUEST, value: id, mod, app };
  },
  getDeletions(activeTab, cb = () => { }) {
    return { type: types.DELETIONS_REQUESTED, value: activeTab, callback: cb };
  },
  getGlobals(entity, params, cb = () => { }) {
    return { type: types.GET_GLOBALS_REQUESTED, value: entity, callback: cb, params };
  },
  updateGlobal(entity, payload, cb = () => { }, errorCallback = () => { } ) {
    return { type: types.UPDATE_GLOBAL_REQUESTED, value: { entity, payload }, callback: cb, errorCallback };
  },
  mergeGlobal(entity, payload, cb = () => { }, errorCallback = () => { }) {
    return { type: types.MERGE_GLOBAL_REQUESTED, value: { entity, payload }, callback: cb, errorCallback };
  },
  mergeUser(entity, payload, cb = () => { }, errorCallback = () => { }) {
    return { type: types.MERGE_USER_REQUESTED, value: { entity, payload }, callback: cb, errorCallback };
  },
  checkMergeGlobal(entity, payload, cb = () => { }, errorCallback = () => { }) {
    return { type: types.CHECK_MERGE_GLOBAL_REQUESTED, value: { entity, payload }, callback: cb, errorCallback };
  },
};

const reducer = (state = admin, action) => {
  switch (action.type) {
    case types.USERS_STATS_REQUESTED:
    case types.USERS_REQUESTED:
      return {
        ...state,
        loading: true,
      }
    case types.USERS_DETAIL_REQUESTED:
      return {
        ...state,
        loading: true,
        details: {}
      }
    case types.USERS_REQUEST_SUCCEDDED:
      return {
        ...state,
        loading: false,
        users: action.value,
      }

    case types.DELETIONS_REQUEST_SUCCEDDED:
      return {
        ...state,
        loading: false,
        deletions: action.value,
      }
    case types.GET_GLOBALS_REQUESTED:
    case types.MERGE_GLOBAL_REQUESTED:
    case types.CHECK_MERGE_GLOBAL_REQUESTED:
    case types.UPDATE_GLOBAL_REQUESTED:
    case types.MERGE_USER_REQUESTED:
      return {
        ...state,
        retrived: false,
      }
    case types.GET_GLOBALS_SUCCEDDED:
    case types.MERGE_GLOBAL_SUCCEDDED:
    case types.MERGE_USER_SUCCEDDED:
    case types.UPDATE_GLOBAL_SUCCEDDED:
      state.globals[action.value.view] = action.value.data;
      return {
        ...state,
        loading: false,
        retrived: true,
      };

    case types.CHECK_MERGE_GLOBAL_SUCCEDDED: 
      state.globals[action.value.view] = action.value.data;
      return {
        ...state,
        loading: false,
        retrived: true,
      };
    case types.GET_GLOBALS_FAILED:
    case types.MERGE_GLOBAL_FAILED:
    case types.MERGE_USER_FAILED:
    case types.CHECK_MERGE_GLOBAL_FAILED:
      state.globals[action.value.view] = [];
      return {
        ...state,
        loading: false,
      };

    case types.USERS_REQUEST_FAILED:
      return {
        ...state,
        loading: false,
      }
    case types.USERS_DETAIL_REQUEST_SUCCEDDED:
      return {
        ...state,
        loading: false,
        details: action.value,
      }

    case types.USERS_DETAIL_REQUEST_FAILED:
      return {
        ...state,
        details: {},
        loading: false,
      }

    case types.USER_CONFIRMATION_REQUEST:
      return {
        ...state,
      }
    case types.USERS_STATS_SUCCEDDED:
      return {
        ...state,
        loading: false,
        cardData: state.cardData.map(d => {
          d.value = action.value.find(c => c.id === d.id).value;
          return d;
        }),
      }
    default:
      return state;
  }
};

export default reducer;
